var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-empty"},[_c('card',[_c('FolderIcon',{attrs:{"size":"36"}}),_c('p',{staticClass:"mt-2"},[_vm._v(" No Case Found ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }